module.exports = __webpack_public_path__ + "static/media/DSCF0476-HepoiYgs.42f1bac3.JPG";